import { useTranslations } from '@vocab/react';
import { Alert, TextLinkButton, Text } from 'braid-design-system';
import React, { useCallback } from 'react';

import translations from 'src/components/Profile/CreateResume/Page/.vocab';
import { Link } from 'src/components/Router/Link';
import { READ } from 'src/consts';
import type { Card } from 'src/types';

import {
  Validation,
  useCreateResumeErrorMessage,
} from '../../Validation/Validation';
import { isNotCreateResumeOptionalFields } from '../../Validation/utils';
import { useGetCreateResumeRoutes } from '../../routes';

type FormattedRoute =
  | 'Licences'
  | 'Skills'
  | 'Education'
  | 'Languages'
  | 'Career history'
  | 'Personal details'
  | 'Summary'
  | 'Finish resume';

export const PageErrorMessage = () => {
  const { t } = useTranslations(translations);

  const format = useCallback(
    (string: string) => {
      const titleCased = `${string.substr(0, 1).toUpperCase()}${string.substr(
        1,
      )}`;
      const formattedRoute = titleCased.replace('-', ' ');
      return t(formattedRoute as FormattedRoute);
    },
    [t],
  );

  const errorMessage = useCreateResumeErrorMessage();
  const createResumeRoutes = useGetCreateResumeRoutes();

  return (
    <Alert tone="caution" data={{ automation: 'page-error-message' }}>
      <Text>
        {createResumeRoutes
          .filter(isNotCreateResumeOptionalFields)
          .filter((name) => name !== 'finish-resume')
          .map((route) => (
            <Validation
              name={route}
              renderOnInvalid
              key={`${route}-validation`}
            >
              <Link mode={READ} component={TextLinkButton} to={route as Card}>
                {format(route)} - {errorMessage[route]}
              </Link>{' '}
              <br />
            </Validation>
          ))}
      </Text>
    </Alert>
  );
};
